import React from 'react';
import Model3D from '@/components/Model3D';

const ModelViewer: React.FC = () => {
  return (
    <div className="w-full h-screen">
      <Model3D modelPath="/models/awijirun_project.glb" />
    </div>
  );
};

export default ModelViewer; 